<div class="footer">
    <div class="container">
      <div class="logo">
        <div class="col-sm-2">
          <a routerLink="/home"><div class="company-logo"></div></a>
        </div>
      </div>
      <div class="footer-content">
        <div class="quick-link-tab col-sm-2">
          <table>
            <tr>
              <th>Quick Link</th>
            </tr>
            <tr>
              <td><a routerLink="/about">About</a></td>
            </tr>
            <tr>
              <td><a routerLink="/product">Product</a></td>
            </tr>
            <tr>
              <td><a routerLink="/mission">Mission & Vision</a></td>
            </tr>
            <tr>
              <td><a routerLink="/campaign">Campaign</a></td>
            </tr>
            <tr>
              <td><a routerLink="/news">News</a></td>
            </tr>
            <tr>
              <td><a routerLink="/gallery">Gallery</a></td>
            </tr>
            <tr>
              <td><a routerLink="/achievement">Achievement</a></td>
            </tr>
            <tr>
              <td><a routerLink="/sustainability">Sustainability</a></td>
            </tr>
          </table>
        </div>
  
        <div class="contact-tab col-sm-5">
          <table>
            <tr>
              <th colspan="2">Contact</th>
            </tr>
            <tr>
              <td>Email</td>
              <td>: admin@senghinrubber.com</td>
            </tr>
            <tr>
              <td>Phone:</td>
              <td>: (+6) 09-9601348</td>
            </tr>
            <tr>
              <td>Fax</td>
              <td>: (+6) 09-9606188</td>
            </tr>
          </table>
          <div class="table-icon">
            <table>
              <tr>
                <td>
                  <div class="facebook-icon" (click)="redirectToFb()"></div>
                </td>
                <td>
                  <div class="linkedin-icon" (click)="redirectToLink()"></div>
                </td>
              </tr>
            </table>
          </div>
        </div>
  
        <div class="location-tab col-sm-3">
          <table>
            <tr>
              <th>Location</th>
            </tr>
            <tr>
              <td><a routerLink="/map">Map</a></td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  
    <div class="copyright-section">
      <p><span class="copyright-name">©2021 Seng Hin Rubber (M) Sdn. Bhd.</span> All rights reserved.</p>
    </div>
  </div>
  